module.exports = __webpack_public_path__ + "media/images/weather/413_day-30c834dfd4a5e43b5fb262f52f0ba935.png";